export var BattlesRequestStatus;
(function (BattlesRequestStatus) {
    BattlesRequestStatus[BattlesRequestStatus["Invalid"] = 1] = "Invalid";
    BattlesRequestStatus[BattlesRequestStatus["Open"] = 2] = "Open";
    BattlesRequestStatus[BattlesRequestStatus["Active"] = 3] = "Active";
    BattlesRequestStatus[BattlesRequestStatus["Closed"] = 4] = "Closed";
})(BattlesRequestStatus || (BattlesRequestStatus = {}));
export var BattlesType;
(function (BattlesType) {
    BattlesType[BattlesType["hypeboard_battle"] = 1] = "hypeboard_battle";
    BattlesType[BattlesType["head2head_battle"] = 2] = "head2head_battle";
    BattlesType[BattlesType["artist_hype_change"] = 3] = "artist_hype_change";
})(BattlesType || (BattlesType = {}));
//# sourceMappingURL=Battles.enums.js.map